import { useEffect } from 'react';
import { useDiscoveredChannelsStore } from '../stores/discoveredChannels.store';

export const useDiscoveredChannels = () => {
  const store = useDiscoveredChannelsStore();
  const load = useDiscoveredChannelsStore((state) => state.load);

  useEffect(() => {
    load();
  }, [load]);

  return store;
};
